/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Upload_TitleInputs */

const en_homepage_features_upload_title = /** @type {(inputs: Homepage_Features_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listen to anything, anywhere`)
};

const es_homepage_features_upload_title = /** @type {(inputs: Homepage_Features_Upload_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escucha cualquier cosa, en cualquier lugar`)
};

/**
* | output |
* | --- |
* | "Listen to anything, anywhere" |
*
* @param {Homepage_Features_Upload_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_upload_title = /** @type {((inputs?: Homepage_Features_Upload_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Upload_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_upload_title(inputs)
	return en_homepage_features_upload_title(inputs)
});